<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-select
          size="mini"
          v-model="selectValue"
          placeholder="请选择"
          style="width: 234px"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button
          style="margin-left: 10px;"
          type="primary"
          plain
          icon="el-icon-top-right"
          size="mini"
          @click="selectFileExport"
          >导出</el-button
        >
      </div>
    </div>
    <analysis-ls
      v-if="selectValue == 0"
      :resize="resize"
      :selectValue="selectValue"
    ></analysis-ls>
    <analysis-lec
      v-if="selectValue == 1"
      :resize="resize"
      :selectValue="selectValue"
    ></analysis-lec>
  </div>
</template>

<script>
import AnalysisLs from "./components/RiskIdentificationAnalysisLs";
import AnalysisLec from "./components/RiskIdentificationAnalysisLec";
export default {
  name: "RiskIdentificationAnalysis",
  components: {
    AnalysisLs,
    AnalysisLec
  },
  props: {},
  data() {
    return {
      selectValue: 0,
      options: [
        { label: "风险矩阵法（LS）", value: 0 },
        { label: "教学条件危险性分析评价法（LEC）", value: 1 }
      ],
      resize: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    async selectFileExport() {
      let num = this.selectValue;
      let req = {
        schoolId: this.$store.state.schoolId,
        assessType: num
      };
      let name = "";
      if (num == 0) {
        name = "危险源辨识及风险分析（LS）";
      } else {
        name = "危险源辨识及风险分析（LEC）";
      }
      this.$Common.exportData(
        req,
        "exportRiskIdentificationAnalysis",
        name,
        false,
        ".docx"
      );
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.risk_level_one,
.risk_level_two,
.risk_level_three,
.risk_level_four {
  height: 100%;
  text-align: center;
}
.measure-info {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.table_box {
  &.el-table--enable-row-hover {
    background-color: #fff !important;
    /deep/ tbody {
      tr:hover > td {
        background-color: #fff !important;
      }
    }
  }
  /deep/ .el-table__body {
    height: 100%;
    tr > td {
      padding: 0px;
      .cell {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 10px;

        .risk_level_one,
        .risk_level_two,
        .risk_level_three,
        .risk_level_four {
          margin: -10px;
          width: calc(100% + 20px);
          height: calc(100% + 20px);
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  tbody {
    tr:hover > td {
      background-color: #fff !important;
    }
  }
}
</style>
